module.exports = __webpack_public_path__ + "static/media/04_avatar_female.60ffcb80.png";